










































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { getInvoiceConfigHeaders } from '@/views/admin/invoiceConfig/invoice';
import { storeService } from '@/shared';
import { InvoiceConfig } from '@/models/admin/store';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    Stores: () => import('@/components/common/store.select.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class InvoiceConfigListPage extends Base {
  public headers: VHeaders[] = getInvoiceConfigHeaders(this);
  public invoiceList: InvoiceConfig[] = [];
  public pagination = new PaginationModel('name');
  public loading: boolean = false;
  public storeId: number;
  public actions: any[] = [];

  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('shifts.deleteDialogTitle') as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    loading: false,
    onAction: (): void => {
      this.deleteConfig();
    },
  };

  public invoiceToDelete: InvoiceConfig = {
    id: '',
    key: '',
    value: [],
  };

  public preventPaginationCall: boolean = false;

  public setActions() {
    this.actions = [
      {
        type: 'link',
        icon: 'fas fa-edit',
        title: this.$t('shifts.shiftGridHeaders.gridAction.edit') as string,
        action: (model: InvoiceConfig, storeId: string) => {
          return {
            name: 'admin.invoice.edit',
            params: { id: model.id, storeId: this.storeId },
          };
        },
      },
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$t('shifts.shiftGridHeaders.gridAction.delete') as string,
        color: 'error',
        action: (model: InvoiceConfig, storeId: string) => {
          this.confirmDelete(model);
        },
      },
    ];
  }

  public created() {
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
    } else {
      this.storeId = this.userSession.storeId;
    }
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }

  public callMethod(methodName): void {
    if (methodName === 'addInvoice') {
      this.$router
        .push({
          name: 'admin.invoice.add',
          params: { storeId: this.storeId.toString() },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
  }

  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: 'Add Invoice Config',
      disabled: false,
      visible: true,
      class: 'btn',
      label: 'Add Invoice Config',
      click: 'addInvoice',
      icon: 'fas fa-plus-circle',
    });
    this.$emit('updateToolBar', buttons);
  }

  public mounted() {
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.setActions();
    if (!this.isAuthorizedToAccess(['SuperAdmin', 'T-Admin', 'E-Admin'])) {
      this.getInvoiceConfig();
    }
  }

  public async getInvoiceConfig(): Promise<void> {
    try {
      this.loading = true;
      const configList = await storeService.getInvoiceConfig(this.storeId);
      this.invoiceList = configList.results;
      this.pagination.totalItems = configList.total;
    } finally {
      this.loading = false;
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
  }

  public confirmDelete(item: InvoiceConfig): void {
    this.deleteDialog.model = true;
    this.invoiceToDelete = item;
  }

  public async deleteConfig(): Promise<void> {
    try {
      this.deleteDialog.loading = true;
      await storeService.delete(this.invoiceToDelete.id, this.storeId);
      this.deleteDialog.model = false;
      this.preventPaginationCall = true;
      this.showAlert(true, 'Config Deleted Successfully.');
      this.getInvoiceConfig();
    } finally {
      this.deleteDialog.loading = false;
    }
  }
  public updateStore(storeId: number): void {
    this.storeId = storeId;
    this.getInvoiceConfig();
  }
}
